// extracted by mini-css-extract-plugin
export var completeButton = "StockTakeGroup-module--completeButton--MdXW+";
export var item = "StockTakeGroup-module--item--fpZwZ";
export var mergedSub = "StockTakeGroup-module--mergedSub--SJhi3";
export var statusBulb = "StockTakeGroup-module--statusBulb--fTEwb";
export var subStockTake = "StockTakeGroup-module--subStockTake--KWM+S";